import { useTranslation } from "react-i18next";
import { ArrowRight, Download } from "lucide-react";
import { Reveal } from "../ui/Reveal";
import { PillButton } from "../ui/decorations";
import { PwaInstallButton } from "../ui/PwaInstallButton";

interface FinalCtaProps {
  onLoginClick: () => void;
}

/** CTA final em bloco ink sólido com glow laranja. */
export function FinalCta({ onLoginClick }: FinalCtaProps) {
  const { t } = useTranslation("landing");
  return (
    <section className="relative py-28 md:py-32 bg-ink overflow-hidden">
      {/* Glow que respira */}
      <div className="absolute left-1/2 top-1/2 w-[560px] h-[560px] max-w-[90vw] rounded-full bg-primary-600/25 blur-[130px] pointer-events-none animate-glow-breathe" />
      {/* Textura de pontos */}
      <div
        className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage: "radial-gradient(circle, #fff 1px, transparent 1px)",
          backgroundSize: "28px 28px",
        }}
      />

      <Reveal className="relative z-10 max-w-3xl mx-auto px-6 text-center">
        <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-extrabold text-white tracking-tight leading-[1.1] text-balance">
          {t("finalCta.title")}
        </h2>
        <p className="mt-6 text-primary-200/80 text-base leading-relaxed">
          {t("finalCta.subtitle")}
        </p>
        <PillButton
          id="final-cta-btn"
          onClick={onLoginClick}
          className="mt-10 px-10 py-4 bg-primary-500 hover:bg-primary-400 text-ink text-base"
        >
          {t("finalCta.cta")}
          <ArrowRight size={18} />
        </PillButton>

        {/* Convite a instalar como app — some sozinho quando não instalável. */}
        <div className="mt-5 flex justify-center">
          <PwaInstallButton className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold text-primary-100 border border-primary-200/25 hover:bg-white/5 transition-colors cursor-pointer">
            <Download size={16} />
            {t("finalCta.install")}
          </PwaInstallButton>
        </div>
      </Reveal>
    </section>
  );
}
